//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    components: {
    },
    props: {
        official_customer_service: {
            type: Object
        }
    },
    methods: {
        tapJoinGroup() {
            wx.navigateTo({
                url: `/web_page?link=${encodeURIComponent('https://mp.weixin.qq.com/s/2n2XCJLQU1wmoA99hOPcoA')}&title=成都购房通`
            })
        }
    }
}
